import React, { useContext } from 'react'
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import Select from 'react-select';
import { themeOptions } from '../Styles/theme';
import { ThemeContext } from '../Context/ThemeContext';
import { auth } from '../firebaseconfig';
const Footer = () => {
   
    const {settheme,defaultval}=useContext(ThemeContext)

    const handlechange =(e)=>{
        console.log(e.value)
        settheme(e.value)
        localStorage.setItem('theme',JSON.stringify(e.value))
    }
  return (
    <div className='footer'>
    <div className='links'>
    {/* Social media */}
    <GitHubIcon />
    <LinkedInIcon />
    </div>
    <div className='themes'>
     {/* select button will go */}
        <Select options={themeOptions}
            onChange={handlechange}
            defaultValue={{value:defaultval,label:defaultval.label}}
        />
    </div>
    </div>
  )
}
export  default Footer